import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomStepper = styled(Stepper)({
  '& .MuiStepLabel-root .Mui-completed': {
    color: '#26a69a',
  },
  '& .MuiStepLabel-root .Mui-active': {
    color: '#26a69a',
  },
  '& .MuiStepConnector-line': {
    borderColor: '#e0e0e0',
  },
  '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
    borderColor: '#26a69a',
  },
  '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
    borderColor: '#26a69a',
  },
});

/**
 * MuiStepper component
 * @param {Array} steps - Array of { label, key } objects
 * @param {string} activeStep - key of the current active step
 */
function MuiStepper({ steps, activeStep }) {
  const activeIndex = steps.findIndex(s => s.key === activeStep);

  return (
    <CustomStepper activeStep={activeIndex} alternativeLabel>
      {steps.map((step) => (
        <Step key={step.key}>
          <StepLabel>{step.label}</StepLabel>
        </Step>
      ))}
    </CustomStepper>
  );
}

export default MuiStepper;